import script from "./customContentSectionHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./customContentSectionHeader.vue?vue&type=script&setup=true&lang=js"

import "./customContentSectionHeader.vue?vue&type=style&index=0&id=1a21ccc2&scoped=true&lang=css"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a21ccc2"]])

export default __exports__